import { useQuery } from "@tanstack/react-query"
import apiRoutes from "../apiRoutes"
import api, { removeUndefinedAndNull } from "../utils"
// import useUrlState from "./use-url-state"

type PaymentParams = {
    country_id?: number;
    allow_debit?: boolean;
    allow_credit?: boolean;
}

export const usePaymentMethods = ({ country_id, allow_debit, allow_credit }: PaymentParams) => {
    const fetchPayment = async () => {
        const res = await api.post(apiRoutes.paymentMethods, removeUndefinedAndNull({
            type: "fetch_services",
            filters: (country_id || allow_credit || allow_debit) ? removeUndefinedAndNull({
                country_id: country_id ?? undefined,
                allow_debit: allow_debit ?? undefined,
                allow_credit: allow_credit ?? undefined
            }) : undefined

        }))
        return res.data
    }

    const { data, ...rest } = useQuery<PaymentMethods>({
        queryFn: fetchPayment,
        queryKey: ['fetch_payment_methods']
    })

    return {
        paymentMethods: data?.info,
        ...rest
    }
}


export const useUserPaymentMethods = () => {
    // const [type] = useUrlState('type')
    const fetchPayment = async () => {
        const res = await api.post(apiRoutes.paymentMethods, {
            type: "fetch_payment_methods",
            // filters: {
            //     payment_type: type === 'buy' ? "credit" : "debit"
            // }
        })
        return res.data
    }

    const { data, ...rest } = useQuery<UserPaymentDetails>({
        queryFn: fetchPayment,
        queryKey: ['user_payment_methods']
    })

    return {
        paymentMethods: data?.info,
        ...rest
    }
}